<template>
  <card dis-hover class="acts-item" :padding="8" @click.native="openAct">
    <div :class="`acts-item__common-info ${all ? 'full-width' : ''}`">
      <tag class="status act" :color="getActStatusColor(act.act_status)">
        {{ act.act_status }}
      </tag>
      <div class="acts-item__name">
        <span class="ms-subhead">
          Акт №{{ act.number }}
        </span>
        <span v-if="act.is_original_exists" class="ms-help">
          (оригинал получен)
        </span>
      </div>
    </div>
    <div class="acts-item__roadmap-info">
      <div class="acts-item__stage-title ms-text">
        Этапы: {{ getRoadmapsNames() }}
      </div>
    </div>
    <div class="acts-item__costs">
      <tag class="ms-costs" color="primary">
        {{ getFormattedCosts(act.costs, false, act.contract_with_vat) }}
      </tag>
    </div>
  </card>
</template>

<script>
import {
  getFormattedCosts,
  getActStatusColor,
  formatDefaultDate
} from '@/utils'

export default {
  props: ['act', 'all'],
  methods: {
    openAct () {
      if (this.all) this.$store.commit('SET_COME_FROM', 'acts')

      this.$emit('open-act', {
        ...this.act,
        contract_id: this.act.contract_id
      })
    },
    getRoadmapsNames () {
      return this.act.act_roadmaps
        .filter(r => r.roadmap_name)
        .map(r => r.roadmap_name)
        .join(', ')
    },
    getActStatusColor,
    getFormattedCosts,
    formatDefaultDate
  }
}
</script>

<style lang="less">
.acts-item {
  margin-bottom: 4px;
  cursor: pointer;

  &:hover {
    border-color: rgba(@primary-color, 0.6) !important;
  }

  .ivu-tag {
    margin: 0;
  }

  .ivu-card-body {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__common-info {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    width: 30%;

    &.full-width {
      flex: 1;
    }
  }

  &__name {
    margin-left: 16px;
    flex-shrink: 0;

    .ms-help {
      font-size: 11px;
      margin-left: 4px;
    }
  }

  &__roadmap-info {
    width: 35%;
  }

  &__roadmap-dates {
    font-size: 11px;

    span:first-child {
      margin-right: 8px;
    }
  }

  &__costs {
    text-align: right;
    width: 16%
  }
}
</style>
